module.exports = __webpack_public_path__ + "static/media/workingmemory-words-7.26d5b351.mp3";